import welcomeScreen from "./assets/mobile-screenshots/IMG_3372.jpeg";
import loginScreen from "./assets/mobile-screenshots/IMG_3373.jpeg";
import signupScreen from "./assets/mobile-screenshots/IMG_3374.jpeg";
import findClubScreen from "./assets/mobile-screenshots/IMG_3375.jpeg";
import clubsScreen from "./assets/mobile-screenshots/IMG_3376.jpeg";
import scheduleScreen from "./assets/mobile-screenshots/IMG_3377.jpeg";

export const landingMobileScreenshot = {
  src: welcomeScreen,
  alt: "Nexus Mobile welcome screen",
};

export const mobilePageScreenshots = [
  {
    src: loginScreen,
    alt: "Nexus Mobile player login screen",
    label: "Login",
  },
  {
    src: signupScreen,
    alt: "Nexus Mobile registration screen",
    label: "Registration",
  },
  {
    src: findClubScreen,
    alt: "Nexus Mobile club access screen",
    label: "Find a Club",
  },
  {
    src: clubsScreen,
    alt: "Nexus Mobile clubs list screen",
    label: "Clubs",
  },
  {
    src: scheduleScreen,
    alt: "Nexus Mobile club schedule screen",
    label: "Schedule",
  },
];
